import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { connect } from 'react-redux';
import Auth from '@aws-amplify/auth';
import Cache from '@aws-amplify/cache';
import ProtectedRoute from './protectedRoutes';
import { ThemeProvider } from 'styled-components';
import { lightThemes, darkThemes } from '../Data/themeSheet';
import { history } from '../Store';
import { setAccessToken, Signout } from '../Actions';
import { cognitoLogout } from '../utils/amplify-config';
import userLog from '../utils/analytics';
import navigator from '../utils/navigator';
import LoadableHOC from './loadableHOC';
import Home from '../Components/Home';
import RegionalHome from '../Components/RegionalHome';
import B2BLanding from '../Components/B2BLandingPage';
import ErrorBoundary from '../Components/ui/ErrorBoundary';

// const Home = LoadableHOC("Home");
const Signup = LoadableHOC('Signup');
const Login = LoadableHOC('Login');
const ForgotPassword = LoadableHOC('ForgotPassword');
const ChangePassword = LoadableHOC('ChangePassword');
const Contact = LoadableHOC('Contact');
const ConfirmSignup = LoadableHOC('ConfirmSignup');
const EmailUnSubscribeComponent = LoadableHOC('EmailUnSubscribe');

const AffiliateDashboard = LoadableHOC('Affiliate/AffiliateDashboard');
const Affiliate = LoadableHOC('Affiliate/AffiliateAuthentication');
const AffiliateLanding = LoadableHOC('Affiliate');

const Terms = LoadableHOC('Terms');
const Privacy = LoadableHOC('Privacy');
const Cookie = LoadableHOC('CookiePolicy');
const RefundPolicy = LoadableHOC('RefundPolicy');
const Blogs = LoadableHOC('Blogs');
const DSAnimTutorials = LoadableHOC('Blogs/Content/dsAnimTutorials');
const LearnProgrammingAnimWay = LoadableHOC('Blogs/Content/learnProgrammingAnimWay');
const VisualizingPointers = LoadableHOC('Blogs/Content/visualizingPointers');
const SuccessStories = LoadableHOC('SuccessStories');
const BrokenPage = LoadableHOC('ui/404');
const NewFeedbackPage = LoadableHOC('NewFeedbackPage');
// const StudentOffer = LoadableHOC('StudentOffer');

const DSA = LoadableHOC('Packages/DSA');
const CProgramming = LoadableHOC('Packages/CProgramming');
const Python = LoadableHOC('Packages/Python');
// const ProblemSolvingBasics = LoadableHOC('Packages/ProblemSolvingBasics');
// const ProblemSolvingDSA = LoadableHOC('Packages/ProblemSolvingDSA');
// const Recursion = LoadableHOC('Packages/Recursion');
// const Patterns = LoadableHOC('Packages/Patterns');
const DoubtSupport = LoadableHOC('DoubtSupport');
const Feedback = LoadableHOC('Feedback');
const DSAJava = LoadableHOC('Packages/DSAJava');
const DSAPython = LoadableHOC('Packages/DSAPython');
const DSACPP = LoadableHOC('Packages/DSACPP');
const DSAJs = LoadableHOC('Packages/DSAJs');
const DSACSharp = LoadableHOC('Packages/DSACSharp');
// const DsAlgo = LoadableHOC('Packages/DsAlgo');
const BeginnersCombo = LoadableHOC('Packages/BeginnersCombo');
const PythonNonIT = LoadableHOC('Packages/PythonGeneral');
const DSAInterview = LoadableHOC('Packages/DSAInterview');
const DSAPythonCombo = LoadableHOC('Packages/PythonDsaCombo');
const DSACPrgCombo = LoadableHOC('Packages/CPrgDsaCombo');
const FrontendDevelopment = LoadableHOC('Packages/FrontendDevelopment');
const InterviewPreparation = LoadableHOC('Packages/InterviewPreparation');
const DataAnalysis = LoadableHOC('Packages/DataAnalysis');
const RegionalAnimationCourses = LoadableHOC('Packages/RegionalAnimationLanding');
const RegionalExpertCourses = LoadableHOC('Packages/RegionalExpertLanding');
const Selenium = LoadableHOC('Packages/Selenium');

const CourseCounselling = LoadableHOC('CourseCounselling');
const IndividualPricingCourses = LoadableHOC('SpecialOfferPages/IndividualPricingCourses');
const PricingAvailablePackages = LoadableHOC('SpecialOfferPages/PricingAvailablePackages');
const IndividualSpecialPricing = LoadableHOC('SpecialOfferPages/IndividualSpecialPricing');
const PackagesSpecialPricing = LoadableHOC('SpecialOfferPages/PackagesSpecialPricing');
const IndividualPricingCoursesPPP = LoadableHOC('SpecialOfferPages/IndividualPricingCoursesPPP');
const StudentOfferPage = LoadableHOC('StudentOfferPage');
const Regionals = LoadableHOC('Packages/Regionals');
const GroupPurchase = LoadableHOC('GroupPurchase');

const Courses = LoadableHOC('Courses');
const LearningPage = LoadableHOC('LearningPage');
const PartnerPlus = LoadableHOC('PartnerPlus');
const CodeJuniors = LoadableHOC('CodeJuniors');

const Dashboard = LoadableHOC('Dashboard');
const Account = LoadableHOC('Account');
const Profile = LoadableHOC('Dashboard/profile');
const DashboardSideNavigation = LoadableHOC('Dashboard/sideNavigation');
const OpenProfile = LoadableHOC('Profile');
const ApplyForJobs = LoadableHOC('Dashboard/jobs');

const Pricing = LoadableHOC('Pricing');
const Checkout = LoadableHOC('Checkout');
const SpecialOfferPurchase = LoadableHOC('Checkout/SpecialOfferPurchase');
const RazorpaySubscription = LoadableHOC('RazorpaySubscription');
const EmailPricing = LoadableHOC('Pricing/EmailPricing');
const PaymentSelector = LoadableHOC('PaymentSelector');
const PaymentSuccessPage = LoadableHOC('Checkout/PaymentMode/PaymentSuccessPage');
const PartnerPlusPricing = LoadableHOC('Pricing/PartnerPlusPricing');
const PartnerPackagePricing = LoadableHOC('Pricing/PartnerPackagePricing');
const RegionalsPricing = LoadableHOC('Pricing/RegionalsPricing');
const RegionalsPackagePricing = LoadableHOC('Pricing/RegionalsPackagePricing');
const CodeJuniorsPricing = LoadableHOC('Pricing/CodeJuniorsPricing');

const TripleOffPricing = LoadableHOC('Pricing/TripleOffPricing');
const RenewalPricing = LoadableHOC('Pricing/RenewalPricing');
const PartnerOffPricing = LoadableHOC('Pricing/PartnerOffPricing');
const RegionalsOffPricing = LoadableHOC('Pricing/RegionalsOffPricing');
const JuniorsOffPricing = LoadableHOC('Pricing/JuniorsOffPricing');
const PartnerPackageOffPricing = LoadableHOC('Pricing/PartnerPackageOffPricing');
const RegionalsPackageOffPricing = LoadableHOC('Pricing/RegionalsPackageOffPricing');

// non recurrent
const NonRecurrentOriginalsPricing = LoadableHOC('Pricing/NonRecurrentOriginalsPricing');
const NonRecurrentPartnersPricing = LoadableHOC('Pricing/NonRecurrentPartnersPricing');
const NonRecurrentRegionalsPricing = LoadableHOC('Pricing/NonRecurrentRegionalsPricing');
const NonRecurrentJuniorsPricing = LoadableHOC('Pricing/NonRecurrentJuniorsPricing');
const NonRecurrentPartnerPackage = LoadableHOC('Pricing/NonRecurrentPartnerPackage');
const NonRecurrentRegionalsPackage = LoadableHOC('Pricing/NonRecurrentRegionalsPackage');

const PromoExpiredPage = LoadableHOC('ui/404/PromoExpiredPage');

class Routes extends Component {
  state = { isLoading: true };

  async componentDidMount() {
    let { setAccessToken } = this.props;

    Auth.currentSession()
      .then((data) => {
        setAccessToken(data.idToken.jwtToken);
        this.setState({ isLoading: false });
      })
      .catch(async (err) => {
        const federatedInfo = await Cache.getItem('federatedInfo');
        const cacheInfo = localStorage.getItem('aws-amplify-cachefederatedInfo');
        if (cacheInfo) {
          let { expires } = JSON.parse(cacheInfo);
          if (expires <= new Date().getTime()) {
            this.props.logout();
            cognitoLogout();
          }
        }
        if (federatedInfo && federatedInfo.token) {
          setAccessToken(federatedInfo.token);
        }
        this.setState({ isLoading: false });
      });

    try {
      if (this.props.user) {
        userLog();
        navigator.trackPages();
      }
    } catch (err) {
      console.log('Unable to retreive the address!');
    }
  }

  render() {
    const { isAuthenticated, darkTheme } = this.props;
    const emailPricingRedirectRoute = '/pricing/?ltoff-mail-pricing';

    return (
      <ThemeProvider theme={darkTheme ? darkThemes : lightThemes}>
        <ConnectedRouter history={history}>
          <ErrorBoundary>
            <Switch>
              <Route exact path="/" component={Home} />

              <Route exact path="/regionals" component={Regionals} />
              <Route exact path="/tamil" component={RegionalHome} />
              <Route exact path="/telugu" component={RegionalHome} />
              <Route exact path="/hindi" component={RegionalHome} />
              <Route exact path="/kannada" component={RegionalHome} />
              <Route exact path="/bengali" component={RegionalHome} />
              <Route exact path="/partner-plus" component={PartnerPlus} />
              <Route exact path="/code-juniors" component={CodeJuniors} />

              <Route exact path="/signup" component={Signup} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/forgotPassword" component={ForgotPassword} />
              <Route exact path="/changePassword" component={ChangePassword} />
              <Route exact path="/confirmSignup" component={ConfirmSignup} />
              <Route exact path="/contact" component={Contact} />
              <Route exact path="/pricing" component={Pricing} />
              <Route exact path="/pricing/:course" component={Pricing} />
              <Route exact path="/checkout" component={Checkout} />
              <Route exact path="/special-offer-purchase" component={SpecialOfferPurchase} />
              <Route exact path="/razorpay" component={RazorpaySubscription} />

              <Route exact path="/courses/:courseID" component={Courses} />
              <Route exact path="/partner-plus-courses/:courseID" component={Courses} />
              <Route exact path="/regionals-tamil-courses/:courseID" component={Courses} />
              <Route exact path="/regionals-telugu-courses/:courseID" component={Courses} />
              <Route exact path="/regionals-hindi-courses/:courseID" component={Courses} />
              <Route exact path="/regionals-kannada-courses/:courseID" component={Courses} />
              <Route exact path="/regionals-bengali-courses/:courseID" component={Courses} />
              <Route exact path="/code-juniors-courses/:courseID" component={Courses} />

              <Route path="/courses/:courseID/:moduleID" component={LearningPage} isAuthenticated={isAuthenticated} />
              <Route path="/partner-plus-courses/:courseID/:moduleID" component={LearningPage} isAuthenticated={isAuthenticated} />
              <Route path="/regionals-tamil-courses/:courseID/:moduleID" component={LearningPage} isAuthenticated={isAuthenticated} />
              <Route path="/regionals-telugu-courses/:courseID/:moduleID" component={LearningPage} isAuthenticated={isAuthenticated} />
              <Route path="/regionals-hindi-courses/:courseID/:moduleID" component={LearningPage} isAuthenticated={isAuthenticated} />
              <Route path="/regionals-kannada-courses/:courseID/:moduleID" component={LearningPage} isAuthenticated={isAuthenticated} />
              <Route path="/regionals-bengali-courses/:courseID/:moduleID" component={LearningPage} isAuthenticated={isAuthenticated} />
              <Route path="/code-juniors-courses/:courseID/:moduleID" component={LearningPage} isAuthenticated={isAuthenticated} />

              {/*<ProtectedRoute path="/account" component={Account} isAuthenticated={isAuthenticated} />*/}
              {/*<ProtectedRoute path="/account/overview" component={Account} isAuthenticated={isAuthenticated} />*/}
              {/*<ProtectedRoute path="/account/edit-profile" component={Account} isAuthenticated={isAuthenticated} />*/}
              {/*<ProtectedRoute path="/account/subscription" component={Account} isAuthenticated={isAuthenticated} />*/}
              {/*<ProtectedRoute path="/account/change-password" component={Account} isAuthenticated={isAuthenticated} />*/}
              {/*<ProtectedRoute path="/account/referral" component={Account} isAuthenticated={isAuthenticated} />*/}

              <Route path="/affiliate" component={AffiliateLanding} />
              <Route path="/affiliateSignup" component={Affiliate} />
              <Route path="/affiliate-resources" component={AffiliateLanding} />
              <ProtectedRoute exact path="/affiliateDashboard" component={AffiliateDashboard} isAuthenticated={isAuthenticated} />
              <Route path="/terms-and-conditions" component={Terms} />
              <Route path="/privacy-policy" component={Privacy} />
              <Route path="/cookie-policy" component={Cookie} />
              <Route path="/reviews" component={SuccessStories} />
              <Route exact path="/blog" component={Blogs} />
              <Route exact path="/blog/data-structure-animation-tutorials" component={DSAnimTutorials} />
              <Route exact path="/blog/learn-programming-animated-way" component={LearnProgrammingAnimWay} />
              <Route exact path="/blog/visualizing-pointers" component={VisualizingPointers} />
              <Route path="/refund-policy" component={RefundPolicy} />
              <Route path="/doubt-support" component={DoubtSupport} />
              <Route path="/feedback" component={Feedback} />

              <Route path="/dsa" component={DSA} />
              <Route path="/c-programming" component={CProgramming} />
              <Route path="/python" component={Python} />
              <Route path="/dsa-java" component={DSAJava} />
              <Route path="/dsa-python" component={DSAPython} />
              <Route path="/dsa-cpp" component={DSACPP} />
              <Route path="/dsa-js" component={DSAJs} />
              <Route path="/dsa-cs" component={DSACSharp} />
              <Route path="/python-for-non-it" component={PythonNonIT} />
              {/*<Route path="/ds-algo/:courseID" component={DsAlgo} />*/}
              <Route path="/ds-algo/c">
                <Redirect to="/dsa" />
              </Route>
              <Route path="/ds-algo/python">
                <Redirect to="/dsa-python" />
              </Route>
              <Route path="/ds-algo/java">
                <Redirect to="/dsa-java" />
              </Route>
              <Route path="/ds-algo/cpp">
                <Redirect to="/dsa-cpp" />
              </Route>
              <Route path="/ds-algo/js">
                <Redirect to="/dsa-js" />
              </Route>
              <Route path="/ds-algo/cs">
                <Redirect to="/dsa-cs" />
              </Route>
              <Route path="/dsa-interview-preparation" component={DSAInterview} />
              <Route path="/python-with-dsa" component={DSAPythonCombo} />
              <Route path="/c-with-dsa" component={DSACPrgCombo} />
              <Route path="/frontend-development" component={FrontendDevelopment} />
              {/*<Route path="/problem-solving-beginners" component={ProblemSolvingBasics} />*/}
              {/*<Route path="/problem-solving-with-dsa" component={ProblemSolvingDSA} />*/}
              {/*<Route path="/coding-interview-patterns" component={Patterns} />*/}
              {/*<Route path="/recursion" component={Recursion} />*/}
              <Route path="/beginners" component={BeginnersCombo} />
              <Route path="/interview" component={InterviewPreparation} />
              <Route path="/data-analysis" component={DataAnalysis} />
              <Route path="/tamil-animation-courses" component={RegionalAnimationCourses} />
              <Route path="/tamil-expert-courses" component={RegionalExpertCourses} />
              <Route path="/selenium" component={Selenium} />

              {/*<Route path="/students" component={StudentOffer} />*/}
              <Route path="/students">
                <Redirect to="/" />
              </Route>
              {/*<Route path="/student-offer" component={StudentOfferPage} />
              <Route path="/student-group-purchase" component={GroupPurchase} />*/}
              <Route path="/student-offer">
                <Redirect to="/pricing" />
              </Route>
              <Route path="/student-group-purchase">
                <Redirect to="/pricing" />
              </Route>
              <Route path="/payment-success" component={PaymentSuccessPage} />
              <Route path="/buy-courses" component={IndividualPricingCourses} />
              <Route path="/buy-packages" component={PricingAvailablePackages} />
              <Route path="/byc-ppp-1932a93c2c3" component={IndividualPricingCoursesPPP} />

              {/*<Route exact path="/partner-plus-pricing" component={PartnerPlusPricing} />
              <Route exact path="/regionals-tamil-pricing" component={RegionalsPricing} />
              <Route exact path="/regionals-telugu-pricing" component={RegionalsPricing} />
              <Route exact path="/regionals-hindi-pricing" component={RegionalsPricing} />
              <Route exact path="/regionals-kannada-pricing" component={RegionalsPricing} />
              <Route exact path="/regionals-bengali-pricing" component={RegionalsPricing} />
              <Route exact path="/code-juniors-pricing" component={CodeJuniorsPricing} />

              <Route exact path="/data-analysis-pricing" component={PartnerPackagePricing} />
              <Route exact path="/tamil-animation-pricing" component={RegionalsPackagePricing} />
              <Route exact path="/tamil-expert-pricing" component={RegionalsPackagePricing} />

              <Route path="/partner-plus-sale" component={PartnerOffPricing} />
              <Route exact path="/regionals-tamil-sale" component={RegionalsOffPricing} />
              <Route exact path="/regionals-telugu-sale" component={RegionalsOffPricing} />
              <Route exact path="/regionals-hindi-sale" component={RegionalsOffPricing} />
              <Route exact path="/regionals-kannada-sale" component={RegionalsOffPricing} />
              <Route exact path="/regionals-bengali-sale" component={RegionalsOffPricing} />
              <Route path="/code-juniors-sale" component={JuniorsOffPricing} />

              <Route exact path="/data-analysis-sale" component={PartnerPackageOffPricing} />

              <Route exact path="/tamil-animation-sale" component={RegionalsPackageOffPricing} />
              <Route exact path="/tamil-expert-sale" component={RegionalsPackageOffPricing} />*/}

              <Route exact path="/partner-plus-pricing">
                <Redirect to="/pricing" />
              </Route>
              {/*<Route exact path="/regionals-tamil-pricing" component={NonRecurrentRegionalsPricing} />*/}
              <Route exact path="/regionals-tamil-pricing">
                <Redirect to="/pricing" />
              </Route>
              <Route exact path="/regionals-telugu-pricing" component={NonRecurrentRegionalsPricing} />
              <Route exact path="/regionals-hindi-pricing" component={NonRecurrentRegionalsPricing} />
              <Route exact path="/regionals-kannada-pricing" component={NonRecurrentRegionalsPricing} />
              <Route exact path="/regionals-bengali-pricing" component={NonRecurrentRegionalsPricing} />
              <Route exact path="/code-juniors-pricing">
                <Redirect to="/pricing" />
              </Route>

              <Route exact path="/data-analysis-pricing" component={NonRecurrentPartnerPackage} />
              <Route exact path="/tamil-animation-pricing" component={NonRecurrentRegionalsPackage} />
              <Route exact path="/tamil-expert-pricing" component={NonRecurrentRegionalsPackage} />

              <Route path="/partner-plus-sale">
                <Redirect to="/pricing" />
              </Route>
              {/*<Route exact path="/regionals-tamil-sale" component={NonRecurrentRegionalsPricing} />*/}
              <Route exact path="/regionals-tamil-sale">
                <Redirect to="/pricing" />
              </Route>
              <Route exact path="/regionals-telugu-sale" component={NonRecurrentRegionalsPricing} />
              <Route exact path="/regionals-hindi-sale" component={NonRecurrentRegionalsPricing} />
              <Route exact path="/regionals-kannada-sale" component={NonRecurrentRegionalsPricing} />
              <Route exact path="/regionals-bengali-sale" component={NonRecurrentRegionalsPricing} />
              <Route path="/code-juniors-sale">
                <Redirect to="/pricing" />
              </Route>

              <Route exact path="/data-analysis-sale" component={NonRecurrentPartnerPackage} />
              <Route exact path="/tamil-animation-sale" component={NonRecurrentRegionalsPackage} />
              <Route exact path="/tamil-expert-sale" component={NonRecurrentRegionalsPackage} />

              {/*<Route exact path="/telugu-animation-sale" component={RegionalsPackageOffPricing} />
              <Route exact path="/hindi-animation-sale" component={RegionalsPackageOffPricing} />
              <Route exact path="/kannada-animation-sale" component={RegionalsPackageOffPricing} />
              <Route exact path="/bengali-animation-sale" component={RegionalsPackageOffPricing} />*/}

              <Route exact path="/lb-nrc-190fd6c18ec" component={NonRecurrentOriginalsPricing} />
              {/*<Route exact path="/ptnr-nrc-190fd6d394d" component={NonRecurrentPartnersPricing} />*/}
              <Route exact path="/ptnr-nrc-190fd6d394d">
                <Redirect to="/pricing" />
              </Route>
              {/*<Route exact path="/rgnl-tamil-nrc-193252a70f6" component={NonRecurrentRegionalsPricing} />*/}
              <Route exact path="/rgnl-tamil-nrc-193252a70f6">
                <Redirect to="/pricing" />
              </Route>
              <Route exact path="/rgnl-telugu-nrc-193252a70f6" component={NonRecurrentRegionalsPricing} />
              <Route exact path="/rgnl-hindi-nrc-193252a70f6" component={NonRecurrentRegionalsPricing} />
              <Route exact path="/rgnl-kannada-nrc-193252a70f6" component={NonRecurrentRegionalsPricing} />
              <Route exact path="/rgnl-bengali-nrc-193252a70f6" component={NonRecurrentRegionalsPricing} />
              {/*<Route exact path="/jnrs-nrc-1932529a0f1" component={NonRecurrentJuniorsPricing} />*/}
              <Route exact path="/jnrs-nrc-1932529a0f1">
                <Redirect to="/pricing" />
              </Route>

              <Route exact path="/ptnr-daly-nrc-1933f19ac85" component={NonRecurrentPartnerPackage} />
              <Route exact path="/rgnl-tamil-anim-nrc-1933f54b282" component={NonRecurrentRegionalsPackage} />
              <Route exact path="/rgnl-tamil-exp-nrc-1933f54b282" component={NonRecurrentRegionalsPackage} />

              {/*<Route path="/buy-courses"><Redirect to="/pricing/?inv-spl" /></Route>
              <Route path="/buy-packages"><Redirect to="/pricing/?inv-spl" /></Route>*/}
              <Route path="/buy-courses-ltd-spl-mar-24">
                <Redirect to="/pricing/?inv-spl" />
              </Route>

              {/*<Route path="/special-offer-courses" component={IndividualSpecialPricing} />
              <Route path="/special-offer-packages" component={PackagesSpecialPricing} />*/}
              <Route path="/special-offer-courses">
                <Redirect to="/pricing/?inv-spl" />
              </Route>
              <Route path="/special-offer-packages">
                <Redirect to="/pricing/?inv-spl" />
              </Route>

              <Route path="/email-unsubscribe" component={EmailUnSubscribeComponent} />
              <Route exact path="/schedule-callback" component={CourseCounselling} />
              <Route path={'/end-off-sale/eoys-2022-nov-upgradetoprime-5BfKdCUNBXbmMbdqXxAyfYQ348i45T'}>
                <Redirect to={emailPricingRedirectRoute} />
              </Route>
              <Route path={'/limited-time-off/ltoff-2023-jan-upgradetoprime-5BfKdCUNBXbmMbdqXxAyfYQ348i45T'}>
                <Redirect to={emailPricingRedirectRoute} />
              </Route>
              <Route path={'/limited-time-off/ltoff-2023-jul-upgradetoprime-JGFF65okjxwq8ss778TXKJK'}>
                <Redirect to={emailPricingRedirectRoute} />
              </Route>
              <Route path={'/limited-time-off/ltoff-2023-aug-upgradetoprime-JGFF65okjxwq8ss778TXKJK'}>
                <Redirect to={emailPricingRedirectRoute} />
              </Route>
              <Route path={'/lb-spl-off-18e6165dbcd'}>
                <Redirect to={emailPricingRedirectRoute} />
              </Route>
              <Route path={'/good-friday-sale'}>
                <Redirect to={emailPricingRedirectRoute} />
              </Route>
              <Route path={'/lb-spl-off-18eb3d5c164'}>
                <Redirect to={emailPricingRedirectRoute} />
              </Route>
              <Route path={'/great-summer-sale'}>
                <Redirect to={emailPricingRedirectRoute} />
              </Route>

              <Route path="/lb-spl-off-18fdd2ad71d" component={TripleOffPricing} />
              <Route path="/lb-spl-off-18ec866b9fd" component={RenewalPricing} />

              <Route exact path="/choose-inr-usd" component={PaymentSelector} />
              <ProtectedRoute path="/dashboard" component={Dashboard} isAuthenticated={isAuthenticated} />
              <ProtectedRoute path="/dashboard/trial-videos" component={Dashboard} isAuthenticated={isAuthenticated} />
              <ProtectedRoute path="/dashboard/mycourses" component={Dashboard} isAuthenticated={isAuthenticated} />
              <ProtectedRoute path="/dashboard/certificate" component={Dashboard} isAuthenticated={isAuthenticated} />
              <ProtectedRoute path="/dashboard/refer-and-earn" component={Dashboard} isAuthenticated={isAuthenticated} />
              <ProtectedRoute path="/dashboard/account" component={Dashboard} isAuthenticated={isAuthenticated} />
              <ProtectedRoute path="/dashboard/partner-plus" component={Dashboard} isAuthenticated={isAuthenticated} />
              <ProtectedRoute path="/dashboard/regionals" component={Dashboard} isAuthenticated={isAuthenticated} />
              <ProtectedRoute path="/dashboard/code-juniors" component={Dashboard} isAuthenticated={isAuthenticated} />
              {/*<ProtectedRoute path="/dashboard/jobs" component={ApplyForJobs} isAuthenticated={isAuthenticated} />*/}
              {isAuthenticated === true ? (
                <ProtectedRoute path="/learners/:name" component={Dashboard} isAuthenticated={isAuthenticated} />
              ) : (
                <Route path="/learners/:name" component={OpenProfile} />
              )}
              <Route exact path="/business" component={B2BLanding} />

              <Route exact path="/promo-expired" component={PromoExpiredPage} />
              <Route component={BrokenPage} />
            </Switch>
          </ErrorBoundary>
        </ConnectedRouter>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = ({ User }) => ({
  user: User.username,
  darkTheme: User.darkTheme && User.darkTheme,
  token: User.token,
  isAuthenticated: User.userSession,
});

const mapDispatchToProps = (dispatch) => ({
  setAccessToken: (token) => dispatch(setAccessToken(token)),
  logout: () => dispatch(Signout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
